var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info Role")]), _c('div', {
    staticClass: "flex justify-between items-start gap-6"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("ID")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.roleDetail.id))])]), _c('div', {}, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Role")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.roleDetail.name))])])]), _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Deskripsi")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.roleDetail.description || '-'))])])])])]), _c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Capability")]), _c('masonry', {
    attrs: {
      "cols": 3,
      "gutter": 30
    }
  }, _vm._l(_vm.roleDetail.permissions, function (item, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(item.id))]);
  }), 0)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }